import { ChangeDetectorRef, Component } from "@angular/core";
import { OrderService } from "../../../order.service";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { MealEnum, DeliveryEnum, ClearEnum, DeliveryEnumEng } from "src/app/frontoffice/catalog/model/deposit.enum";
import { DepositPersonnelModel } from "src/app/frontoffice/catalog/model/deposit.model";
import { Validators } from "@angular/forms";
import { DepositMenuComponent } from "./deposit-menu.component";
import { DepositFormSettingModel } from "./depositformsetting.model";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";

export interface EnumModel {
  Id: number;
  Title: string;
}

@Component({
  selector: "order-deposit",
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.scss"],
})
export class DepositComponent extends BaseListComponent {
  menu = DepositMenuComponent;
  depositformsetting: DepositFormSettingModel;
  formVisible: boolean = true;
  numberOfCooksIsRequired: boolean = true;
  MealTimeDataList: EnumModel[];
  DeliveryTypeDataList: EnumModel[];
  ClearTypeDataList: EnumModel[];
  constructor(
    public order: OrderService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public storage: LocalStoreManager
  ) {
    super();
    if (!this.accountService.userHasPermission(`General:DepositFormSetting`, Permission.viewPermission)) {
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.AccessToThisArea"));
      this.formVisible = false;
    }
  }

  async ngOnInit() {
    this.apiName = "Deposit";
    this.setColumns();
    super.ngOnInit();
    this.MealTimeDataList = this.enumToEnumModelArray(MealEnum);
    this.DeliveryTypeDataList = this.enumToEnumModelArray(DeliveryEnum);
    this.ClearTypeDataList = this.enumToEnumModelArray(ClearEnum);
    this.order.controlsVisibility();
    this.order.cd_Deposit = this.cd;
  }

  enumToArray(enumObj: any): any[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: Number(enumObj[key]), Title: key }));
  }
  enumToEnumModelArray(enumObj: any): EnumModel[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: enumObj[key], Title: key }));
  }

  setColumns() {
    var col: form_control[] = [];
    col = [
      {
        name: "PersonnelId",
        modelName: "PersonnelId",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.Personnel"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "Personnel/GetCooksAndDrivers",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
        required: true,
      },
      {
        name: "Amount",
        modelName: "Amount",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.Amount"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: undefined,
        apiName: "",
        displayMember: "Title",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 300,
        withComma: true,
      },
    ];
    this.columns = col;
    this.orignalColumns = col;
  }

  public afterSavedList(entity: DepositPersonnelModel): void {
    if (!!entity.PersonnelId) {
      const otherRows = this.order.depositPersonnelList.filter((x) => x.PersonnelId !== entity.PersonnelId);
      this.order.calcDepositServiceAmount(otherRows, entity.Amount);
    }
    const depositControls = this.order.depositFormGroup.controls;
    depositControls["ServicesAmount"].setValidators([Validators.required]);
    this.setChangesOnInvoice();
  }

  public afterDeletedList(entity: DepositPersonnelModel): void {
    if (!!entity.PersonnelId) {
      this.order.depositPersonnelList = this.order.depositPersonnelList.filter((x) => x.PersonnelId !== entity.PersonnelId);
      this.order.calcDepositServiceAmount(this.order.depositPersonnelList);
    }
    if (!this.order.depositPersonnelList.length) {
      const depositControls = this.order.depositFormGroup.controls;
      depositControls["ServicesAmount"].clearValidators();
    }
    this.setChangesOnInvoice();
  }

  public setChangesOnInvoice(): void {
    this.order.invoiceChanged = true;
    this.order.detectChanges();
    this.order.calculate();
  }

  public onDeliveryTypeChanges(selectedItem: { Id: number; Title: string }): void {
    const NumberOfCooks = this.order.depositFormGroup.controls["NumberOfCooks"];
    if (selectedItem?.Id === DeliveryEnumEng.cooking) {
      this.numberOfCooksIsRequired = true;
      NumberOfCooks.addValidators([Validators.required]);
      NumberOfCooks.updateValueAndValidity();
      NumberOfCooks.markAsDirty();
      NumberOfCooks.markAsTouched();
      this.order.focus("NumberOfCooks");
    } else {
      this.numberOfCooksIsRequired = false;
      NumberOfCooks.clearValidators();
      NumberOfCooks.updateValueAndValidity();
    }
    this.order.depositFormGroup.updateValueAndValidity();
    this.order.detectChanges();
  }
}
